import Box from "@/components/Box";
import Stack from "@/tpo/Stack";
import ButtonV2 from "@/v2/Buttons";

import NotificationModal from "./NotificationModal";


export default function AlertNotificationModal({
  onClose,
  onButtonClick
}) {

  return (
    <NotificationModal
      onClose={onClose}
      background="linear-gradient(123deg, #5220DD 39.48%, #9747FF 100%)"
      borderRadius={20}
      maxWidth={720}
    >
      <Stack gap={16} pb={80} px={40}>
        <Box fontFamily="gilroyBold" fontSize={[44]} lineHeight={["50px"]} color="white">
          New test markers available
        </Box>
        <Box fontFamily="gilroyMedium" fontSize={[16]} lineHeight={["28px"]} color="white">
          Your patient has new markers available in this report. You can view the updated values
          within the report now, but your patient will not see them until you release the results.
          Once the test results are released, the new markers will also appear in the patient’s
          report.
        </Box>
        <ButtonV2
          color="white"
          withChevron
          sx={{
            color: "dark",
            mr: "auto",
            mt: 40,
          }}
          onClick={onButtonClick}
        >
          view test results
        </ButtonV2>
      </Stack>
    </NotificationModal>
  );
}

AlertNotificationModal.defaultProps = {
  title: "Important update!",
  subtitle: "",
  description: "",
  bulletPoints: [],
  ctaLabel: "",
  ctaHref: "",
  secondaryLabel: "",
  onSecondaryClick: () => {}
};
